import {
  extractCapabilities,
  extractEditor,
  extractTenantAdmin,
  extractUserCategories,
  extractUserGroupRoles
} from 'src/abac/extract';
import { UserDetails } from 'src/api/deinverband-api';
import { Profile } from 'src/types/user';
import { extractAttributeValues } from 'src/utils/attributes-value';
import { parseBackendGender } from 'src/utils/format';
import { mapCompanySummaryToCompany } from './company-summary-to-company';

export const mapUserDetailsToProfile = (
  user: UserDetails | undefined
): Profile | undefined => {
  if (!user || user.id === undefined) return undefined;

  const profile = {
    id: user.id,
    email: user.email || undefined,
    contact: {
      phone: user.phone || undefined,
      mobile: user.mobile || undefined
    },
    groupRoles: extractUserGroupRoles(user.appliedAccessAttributes),
    categoryAccess: extractUserCategories(user.appliedAccessAttributes),
    external: !!user.isExternal,
    defaultNotifications: user.defaultNotificationSettings,
    tagNotifications: user.tagNotificationSettings,
    tenantAdmin: extractTenantAdmin(user.appliedAccessAttributes),
    editor: extractEditor(user.id, user.appliedAccessAttributes),
    capabilities: extractCapabilities(user.appliedAccessAttributes),
    attributes: extractAttributeValues(user.appliedAccessAttributes)
  };

  if (user.isCompanyUser) {
    // company account must have exactly one company
    if (user.companies?.length !== 1)
      console.warn('Company user with ambiguous companies');

    return {
      type: 'company',
      company:
        // HACK: fall back to first company
        !!user.companies?.length
          ? mapCompanySummaryToCompany(user.companies[0])
          : undefined,
      ...profile
    };
  }

  return {
    type: 'personal',
    gender: parseBackendGender(user.gender),
    firstName: user.firstName || undefined,
    lastName: user.lastName || undefined,
    companies:
      user.companies
        ?.map(mapCompanySummaryToCompany)
        .filter((company) => !!company) || [],
    ...profile
  };
};
